export default __webpack_public_path__ + "src/panels/Call/assets/call-e7af6a2e.jpg";